// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-sync-frame,.h-sync-frame__node{display:block;width:100%}.h-sync-frame__node{height:auto;background:transparent;border:0}", ""]);
// Exports
module.exports = exports;
